<template>
  <d2-container>
    <template slot="header">
      <el-select v-model="query.ownerType" clearable size="small" placeholder="归属类型" style="width: 150px; margin-right: 8px">
        <el-option label="个人" value="PERSONAL"></el-option>
        <el-option label="组织" value="ORGANIZATION"></el-option>
      </el-select>
      <el-input v-model="query.ownerId" clearable size="small" placeholder="归属ID" style="width: 160px; margin-right: 8px"></el-input>
      <el-select v-model="query.status" clearable size="small" placeholder="批次状态" style="width: 130px; margin-right: 8px">
        <el-option label="可用" :value="0"></el-option>
        <el-option label="用尽" :value="1"></el-option>
        <el-option label="过期" :value="2"></el-option>
      </el-select>
      <el-input v-model="query.sourceType" clearable size="small" placeholder="来源类型" style="width: 180px; margin-right: 8px"></el-input>
      <el-button type="primary" size="small" icon="el-icon-search" @click="load">搜索</el-button>
    </template>

    <el-table size="small" stripe border :data="records" v-loading="loading">
      <el-table-column prop="id" label="批次ID" width="150"></el-table-column>
      <el-table-column label="归属类型" width="120">
        <template slot-scope="scope">{{ ownerTypeLabel(scope.row.ownerType) }}</template>
      </el-table-column>
      <el-table-column prop="ownerId" label="归属ID" width="150"></el-table-column>
      <el-table-column label="来源" width="170">
        <template slot-scope="scope">{{ sourceTypeLabel(scope.row.sourceType) }}</template>
      </el-table-column>
      <el-table-column prop="originalAmount" label="原始" width="100" align="right"></el-table-column>
      <el-table-column prop="availableAmount" label="可用" width="100" align="right"></el-table-column>
      <el-table-column prop="reservedAmount" label="冻结" width="100" align="right"></el-table-column>
      <el-table-column prop="consumedAmount" label="消费" width="100" align="right"></el-table-column>
      <el-table-column prop="expiredAmount" label="过期" width="100" align="right"></el-table-column>
      <el-table-column label="状态" width="90" align="center">
        <template slot-scope="scope">{{ statusText(scope.row.status) }}</template>
      </el-table-column>
      <el-table-column prop="expireAt" label="过期时间" width="170"></el-table-column>
      <el-table-column label="标题" min-width="160" show-overflow-tooltip>
        <template slot-scope="scope">{{ sanitizeAiText(scope.row.title) }}</template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="170"></el-table-column>
    </el-table>

    <template slot="footer">
      <el-pagination
        :current-page.sync="query.currentPage"
        :page-size="query.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSize"
        @current-change="handlePage"
      ></el-pagination>
    </template>
  </d2-container>
</template>

<script>
import { getAiPointBuckets } from '@/api/ai/rights'
import { ownerTypeLabel, sanitizeAiText, sourceTypeLabel } from './labels'

export default {
  name: 'aiPointBucketManager',
  data () {
    return {
      query: { currentPage: 1, pageSize: 20, ownerType: '', ownerId: '', status: '', sourceType: '' },
      records: [],
      total: 0,
      loading: false
    }
  },
  created () {
    this.load()
  },
  methods: {
    load () {
      this.loading = true
      getAiPointBuckets(this.query).then(res => {
        this.records = (res && res.records) || []
        this.total = Number((res && res.total) || 0)
      }).finally(() => {
        this.loading = false
      })
    },
    handleSize (size) {
      this.query.pageSize = size
      this.load()
    },
    handlePage (page) {
      this.query.currentPage = page
      this.load()
    },
    statusText (status) {
      return status === 0 ? '可用' : (status === 1 ? '用尽' : '过期')
    },
    ownerTypeLabel,
    sourceTypeLabel,
    sanitizeAiText
  }
}
</script>
